const dateTimePicker = {
  methods: {
    getDateTime (fullDate) {
      const dateWithTime = this.$dateFormat.timestamp(fullDate)
      const date = this.$dateFormat.yearlong_month_date(fullDate)
      const hour = this.$moment(fullDate).format('HH')
      const minute = this.$moment(fullDate).format('mm')
      const isEndOfDay = hour === '23' && minute === '59'
      const seconds = isEndOfDay ? '59' : this.$moment(fullDate).format('ss')
      const time = `${hour}:${minute}:${seconds}`
      return {
        dateWithTime,
        date,
        time
      }
    },
    mergeDateTime (newValue, oldValue, mergeType) {
      const { date, time } = this.getDateTime(oldValue)

      if (mergeType === 'date') {
        const { date: newDate } = this.getDateTime(newValue)
        return this.$dateFormat.timestamp(`${newDate} ${time}`)
      }
      return this.$dateFormat.timestamp(`${date} ${newValue}`)
    }
  }
}

export default dateTimePicker
